/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyDetailResponse } from '../../models/api-key-detail-response';

export interface GetApiKey$Params {
  'Active-Tenant-Identifier': string;
  apiKeyId: string;
}

export function getApiKey(http: HttpClient, rootUrl: string, params: GetApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiKey.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('apiKeyId', params.apiKeyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeyDetailResponse>;
    })
  );
}

getApiKey.PATH = '/api-keys/{apiKeyId}';
